import React, { useContext } from 'react';

import { NCRContext } from 'views';
import { UserContext } from 'components/routing';

import { Asterisk, Dropdown } from 'components/form/prototypes';

const RestockCharge = () => {
  const { state } = useContext(NCRContext);
  const { user } = useContext(UserContext);

  const isDisabled = ['GM'].includes(user.role)
    ? state.ncr.status.id > 8
    : state.ncr.status.id > 1;

  return (
    <>
      {state.ncr.return.returnItems.length > 0 && <Asterisk />}
      <Dropdown
        label="Who is responsible for restock charge?"
        name="ncr.return.restock_charge"
        data={state.restock_charge}
        disabled={isDisabled}
      />
    </>
  );
};

export { RestockCharge };
